import Content from "./Content";
import { IWizardStep } from "../../../../wizard/types";
import innerValidator from "../../validators/step2/validator";

export const createConfigStep2: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Add course",
  },
  content: Content,
  validator: innerValidator,
  stepName: "step2",
};
